import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { from, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AppslidereditService {

  url = environment.Url;

  constructor(private http: HttpClient,
    private cookie: CookieService) { }


  // appslider edit
  currencyConfigEdit(data) {


    const httpheaders = new HttpHeaders({
      'Content-Type': [],
      'Accept': 'application/json',
      // 'Token': this.cookie.get('Token')
      'Token': localStorage.getItem('Token')
    });
    return this.http.post(`${this.url}/currencyEdit`, data, {
      headers: httpheaders,
      observe: 'response'
    });
  }

  // get appslider
  getcurrencyConfig(id) {
    const httpheaders = new HttpHeaders({
      'Content-Type': [],
      'Accept': 'application/json',
      // 'Token': this.cookie.get('Token')
      'Token': localStorage.getItem('Token')
    });
    return this.http.get(`${this.url}/currencyPageView/${id}`, {
      headers: httpheaders,
      observe: 'response'
    });
  }


}

